import React from 'react'
import { withTheme } from 'styled-components'
import Icon from 'modules/common/components/icon/Icon'
import { ICONS } from 'modules/common/components/icon/Icons'
import colors from 'modules/common/components/ui/colors'
import './Logo.css'

const renderLogo = (icon, width, height, fill) => {
  return (
    <Icon
      icon={icon}
      width={width}
      height={height}
      fill={fill}
    />
  );
}
const Logo = ({
  min,
  theme: { Logo = 'birdietime'},
  mobile = false,
  icon = ICONS.LOGO_V2,
  width='100%',
  height='100%',
  fill=colors.BRAND_GREEN,
  type='dark'
  }) => {
  return renderLogo(icon, width, height, fill)
}

export default withTheme(Logo)



// WEBPACK FOOTER //
// ./src/modules/common/components/logo/Logo.js